/**
 * ActionIcons — the shared row-action icon buttons (view / edit / delete).
 * One visual language for every table: bordered icon buttons with a tooltip
 * (title) and aria-label. Keep text buttons for uncommon actions (Send,
 * Cancel meeting, Disable, …); these three are the eye/pen/bin convention.
 */

import { Link } from 'react-router-dom';
import { Eye, Pencil, Trash2 } from 'lucide-react';

const BASE = 'inline-flex items-center justify-center w-7 h-7 rounded border transition-colors disabled:opacity-40 disabled:pointer-events-none';
const TONES = {
  view: 'text-accent hover:text-white border-border hover:border-accent',
  edit: 'text-muted hover:text-white border-border hover:border-accent',
  delete: 'btn-ghost-danger border',
} as const;

export function ViewIcon({ to, label = 'View' }: { to: string; label?: string }) {
  return (
    <Link to={to} title={label} aria-label={label} className={`${BASE} ${TONES.view}`}>
      <Eye size={14} />
    </Link>
  );
}

export function EditIcon({ onClick, label = 'Edit', disabled, title }: {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
  title?: string;
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title ?? label}
      aria-label={title ?? label}
      className={`${BASE} ${TONES.edit}`}
    >
      <Pencil size={14} />
    </button>
  );
}

export function DeleteIcon({ onClick, label = 'Delete', disabled, title }: {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
  title?: string;
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title ?? label}
      aria-label={title ?? label}
      className={`${BASE} ${TONES.delete}`}
    >
      <Trash2 size={14} />
    </button>
  );
}
